import { nextTick, ref, toRaw } from 'vue'
import { similarProduct } from '@/apis/associated'

export const formatSimilarProduct = (v: any, rate: number) => ({
  ...v,
  id: v.productSameStyleId,
  code: v.productCode,
  name: v.productTitle,
  img: v.productMainImg,
  type: 'common',
  price: v.productSellPrice ?? 0,
  PriceJpy: (v.productSellPrice ?? 0) * rate ? Math.floor((v.productSellPrice ?? 0) * rate) : 0
})
const formatSimilarProductArr = (data: any, rate: number) => {
  return (data || []).map((t: any) => formatSimilarProduct(t, rate))
}
export default (sourceProduct: any, rate:any, emits: any) => {
  const loading: any = ref(false)
  const list: any = ref([])
  const total = ref()
  const pageData = ref({
    pageNum: 1,
    pageSize: 50
  })

  const getList = () => {
    loading.value = true
    const { thirdItemCode, thirdItemImage } = sourceProduct.value
    similarProduct({
      ...toRaw(pageData.value),
      sourceProductCode: thirdItemCode,
      sourceProductMainImg: thirdItemImage
    }).then((res: any) => {
      list.value = formatSimilarProductArr(res.data?.records, rate.value)
      total.value = res.data.total
      nextTick(() => {
        emits('update:list', list.value)
      })
    }).finally(() => { loading.value = false })
  }

  return [
    loading,
    pageData,
    list,
    total,
    getList
  ]
}
